import { z } from "zod";

export const ParseJobStatus = z.enum(["pending", "processing", "completed", "failed"]);

export const ParseJob = z.object({
  public_id: z.string(),
  uploaded_file_public_id: z.string(),
  status: ParseJobStatus,
  parser_id: z.string().nullable(),
  confidence: z.number().int().nullable(), // 0-100
  error_message: z.string().nullable(),
  retry_count: z.number().int().min(0),
  started_at: z.iso.datetime({ offset: true }).nullable(),
  completed_at: z.iso.datetime({ offset: true }).nullable(),
  created_at: z.iso.datetime({ offset: true }),
  updated_at: z.iso.datetime({ offset: true }),
});

export const ListParseJobsInput = z.object({
  limit: z.coerce.number().int().min(1).max(100).default(50),
  status: ParseJobStatus.optional(),
});

export type ParseJobDto = z.infer<typeof ParseJob>;
export type ParseJobStatusDto = z.infer<typeof ParseJobStatus>;
